import React from 'react';
import clsx from 'clsx';
import useModal from '@/hooks/useModal';
import { RequestDocumentForm } from './RequestDocumentForm';
import { ModalHeaderArrowBack } from '@/components/modals/ModalHeaderArrowBack';

import { DocumentRequiredPayloadItem } from '@/interfaces';
import { usePathname } from 'next/navigation';

interface Props {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	onBack?: () => void;
	caseName?: string;
	isCaseReadOnly?: boolean;
	isStepApproved?: boolean;
	onSubmit?: (data: any) => Promise<void>;
	existingDocuments?: DocumentRequiredPayloadItem[];
	initialData?: DocumentRequiredPayloadItem | null;
}

export const ModalRequestDocument: React.FC<Props> = ({
	open,
	setOpen,
	onBack,
	caseName,
	isCaseReadOnly,
	isStepApproved,
	onSubmit,
	existingDocuments,
	initialData,
}) => {
	const pathname = usePathname();
	const { Modal, show, hide } = useModal();

	const [isMessageBox, setIsMessageBox] = React.useState(false);
	const showMessageBox = pathname.includes('clients');

	const getTitle = () => {
		if (pathname.includes('/applicant-intake')) {
			return isMessageBox ? 'Add page language' : 'Configure Document';
		}
		return isMessageBox ? 'Add Email Language' : 'Request Document';
	};

	React.useEffect(() => {
		if (open) {
			show();
		} else {
			hide();
			if (showMessageBox) {
				setIsMessageBox(false);
			}
		}
	}, [open]);

	const handleClose = () => {
		hide();
		setOpen(false);
	};

	const handleBack = () => {
		if (isMessageBox && showMessageBox) {
			setIsMessageBox(false);
		} else {
			handleClose();
			onBack?.();
		}
	};

	const title = getTitle();

	return (
		<Modal
			classNameCardContainer={clsx('w-full', {
				'md:!w-[500px]': isMessageBox,
				'md:!w-[655px]': !isMessageBox,
			})}
			onClose={handleClose}
			title={
				<ModalHeaderArrowBack
					title={title}
					handleClose={handleClose}
					handleBack={handleBack}
					showBack={isMessageBox || !!onBack}
				/>
			}
			backgroundColor="white"
			avoidClose
		>
			<RequestDocumentForm
				showMessageBox={showMessageBox}
				isMessageBox={isMessageBox}
				setIsMessageBox={setIsMessageBox}
				caseName={caseName}
				isCaseReadOnly={isCaseReadOnly}
				isStepApproved={isStepApproved}
				onSubmit={onSubmit}
				existingDocuments={existingDocuments}
				initialData={initialData}
				open={open}
			/>
		</Modal>
	);
};
